import React, { useState, useEffect } from "react";
import * as Yup from "yup"; // Import Yup for validation
import Form from "@Components/Form";
import eightAxios from "configs/axiosConfig";
import { ROLES_URL, SOS_RECIPIENT } from "configs/constants";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import SaveIcon from "@material-ui/icons/Save";
import { useNotifyContext } from "@Components/Notify";
import { fetchDataFromApi } from "../../utils";

const SOSRecipientList = () => {
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [recipients, setRecipients] = useState([]);
  const [recipientControl, setRecipientControl] = useState({
    recipients : []
  });  

  const setNotify = useNotifyContext();

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(SOS_RECIPIENT)
      .then((response) => {
        if (response.status === 200) {
          setRecipients(response.data.recipients);
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDataFromApi(ROLES_URL+'?from_select=true', setRoles, true);
    fetchDataFromApi(SOS_RECIPIENT, setRecipientControl, false);
    // fetchDetails();
  }, []);

 

  useEffect(() => {
    const workerRole = roles.find((role) => role.name === "Worker");
    if (roles.includes(workerRole)) {
      setRoles(roles.filter((item) => item.name !== "Worker"));
    }
  }, [roles]);

  

  const handleSubmit = (values, { setSubmitting }) => {
    setLoading(true);
    
    eightAxios
      .post(SOS_RECIPIENT, values)
      .then((response) => {
        setRecipients(response.data.recipients);
        setNotify({
          isOpen: true,
          message: "Successfully updated.",
          type: "success",
        });
        setLoading(false);
        fetchDataFromApi(SOS_RECIPIENT, setRecipientControl, false);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
        setSubmitting(false);
        setLoading (false);
      });
  };

   const initialValues = { recipient: recipientControl.recipients };   

  const validationSchema = Yup.object({
    recipient: Yup.array()
      .required("Recipient is required")
      .test("isNotEmpty", "Recipient is required", (value) => value && value.length > 0),
  });

  const formFields = [
    {
      name: "recipient",
      type: "reactselect",
      label: "Recipient List",
      color: "primary",
      required: true,
      size: "medium",
      isMultiSelect: true,
      outerOptions: roles,
    },
    {
      type: "note",
      label: "Note:",
      color: "primary",
      size: "medium",
      gridSize: { xs: 12, sm: 12, md: 12, lg: 12 },
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Save",
      color: "primary",
      startIcon: <SaveIcon />,
    },
  ];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <div>
      <Form
        initialValues={initialValues}
        outerSubmitHandler={handleSubmit}
        validationSchema={validationSchema}
        formFields={formFields}
        formButtons={formButtons}
        formTitle="SOS Recipient"
      />
    </div>
  );
};

export default SOSRecipientList;